import { render, staticRenderFns } from "./modelComparison.vue?vue&type=template&id=6b6ac143&scoped=true&"
import script from "./modelComparison.vue?vue&type=script&lang=js&"
export * from "./modelComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ac143",
  null
  
)

export default component.exports